import { client } from '@hotjar/api-base-client';
import type { ProductDto } from './dto';
import { mapProductCatalogDtoToModel } from './mapper';
import type { BillingPeriod, Currency, ProductCatalog } from './model';

export async function getProductCatalog(
  billingPeriod: BillingPeriod,
  currency: Currency,
  version: 'v1' | 'v2' = 'v1',
): Promise<ProductCatalog> {
  return client<ProductCatalog, ProductDto[]>({
    url: `/api/checkout${
      version === 'v1' ? '' : '/v2'
    }/product_catalog/${billingPeriod?.toLowerCase()}/${currency?.toLowerCase()}`,
    mapResponseData: mapProductCatalogDtoToModel,
  });
}
